<template>
	<div>
		<div class="row">
			<div class="col-12">
				<card>
					<h6 slot="header">Rapporto intervento tecnico</h6>
					<div class="row">
						<div class="col-12 col-md-6 col-lg-3">
							<base-input
								label="Ore motore"
								v-validate="'required'"
								:error="getError('number')"
								v-model="model.engineHour"
								name="number"
								type="number"
								input-size="form-control-lg"
								placeholder="Inserisci ore totali motore" />
						</div>


						<div class="col-12 col-md-6 col-lg-3">
							<base-input
								label="Ore servizio"
								v-validate="'required'"
								:error="getError('number')"
								v-model="model.serviceEngineHour"
								name="number"
								type="number"
								input-size="form-control-lg"
								placeholder="Ore motore dall'ultima revisione E1" />
						</div>

						<div class="col-12 col-md-6 col-lg-3">
							<div class="form-group">
								<label>Referente</label>
								<el-select
									size="large"
									v-if="site"
									v-model="referent"
									input-class="form-control-lg form-control"
									filterable
									placeholder="Seleziona la fase">
										<el-option
											v-for="option in site.emails"
											:value="option._id"
											:label="option.contactName"
											:key="option._id"
										/>
								</el-select>
							</div>
						</div>
					</div>
				</card>
			</div>
			<div class="col-12 col-md-6">
				<card>
					<div class="row">
						<div class="col-12 col-md-6">
							<base-input
								:error="getError('referenceOrderLabel')"
								v-model="model.referenceOrderLabel"
								name="referenceOrderLabel"
								type="text"
								input-size="form-control-lg"
								placeholder="Rif. ordine" />
						</div>
						<div class="col-12 col-md-6">
							<base-input
								:error="getError('referenceOrder')"
								v-model="model.referenceOrder"
								name="referenceOrder"
								type="text"
								input-size="form-control-lg"
								placeholder="Inserisci riferimento " />
						</div>
					</div>
				</card>
				
			</div>
		</div>
		
		<revision-worked-details
			:model="model" />

		<revision-worked-additional-lines 
			:model="model" />

		<card>
			<div slot="header" class="h6">Note</div>
			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label for="anomalyDescription">Anomalia/e riscontrata/e</label>
						<textarea placeholder="Scrivi qui" name="anomalyDescription" v-model="model.anomalyDescription" id="anomalyDescription" class="form-control"></textarea>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label for="activityDescription">Descrizione attività</label>
						<textarea placeholder="Scrivi qui" name="activityDescription" v-model="model.activityDescription" id="activityDescription" class="form-control"></textarea>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label for="clientsNote">Note del cliente</label>
						<textarea placeholder="Scrivi qui" name="clientsNote"  v-model="model.clientsNote" id="clientsNote" class="form-control text-area-notes"></textarea>
					</div>
				</div>
			</div>
		</card>
		
		<card>
			<div slot="header">
				<div class="row align-items-center">
					<div class="col-12 col-md-8">
						<h6>Prodotti utilizzati</h6>
					</div>
					<div class="col-12 col-md-4 text-center text-md-right">
						<base-button
							type="primary"
							@click="addProduct()">
	              			<i class="tim-icons icon-simple-add"></i>
							Aggiungi
						</base-button>
					</div>
				</div>
			</div>
			<el-table :data="model.productsUsed" class="table-product-used">
				<el-table-column
					width="160"
					>
					<template slot-scope="scope">
						<div class="d-flex">
							<base-button type="link" class="text-danger" @click="deleteProductRow(scope.$index)">
											<i class="tim-icons icon-simple-remove"></i>
							</base-button>
							<base-button
								type="link"
								@click="changePosition(scope.$index,-1)"
								:disabled="scope.$index === 0"
								class="m-auto d-block px-2 text-info"
								>
								<i class="tim-icons icon-minimal-up"></i>
							</base-button>	
							<base-button
								type="link"
								:disabled="scope.$index === model.productsUsed.length -1 "
								@click="changePosition(scope.$index,1)"
								class="m-auto d-block px-2 text-info"
								>
								<i class="tim-icons icon-minimal-down"></i>
							</base-button>		
						</div>
					</template>
				</el-table-column>
				<el-table-column
					width="280"
					label="Codice">
					<template slot-scope="scope">
						<base-input 
							@input="checkInput"
							:name="`${scope.$index}code`"
							:error="getError(`${scope.$index}code`)"
							placeholder="Codice"
							v-model="scope.row.code"/>
					</template>
				</el-table-column>
				<el-table-column
					width="400"
					label="Descrizione">
					<template slot-scope="scope">
						<base-input 
							@input="checkInput"
							v-validate="'required'"
							:name="`${scope.$index}description`"
							:error="getError(`${scope.$index}description`)"
							placeholder="Descrizione"
							v-model="scope.row.description"/>
					</template>
				</el-table-column>
				<el-table-column
					width="130"
					label="Quantità">
					<template slot-scope="scope">
						<base-input 
							v-validate="'required|decimal:3'"
							type="number"
							step="0.001"
							:name="`${scope.$index}quantity`"
							:error="getError(`${scope.$index}quantity`)"
							placeholder="qta"
							@input="changeTotalAmountOfProduct(scope.row)"
							v-model="scope.row.quantity"/>
					</template>
				</el-table-column>
				<el-table-column
					width="180"
					label="Costo unitario">
					<template slot-scope="scope">
						<base-input 
							v-validate="'required'"
							type="text"
							step="0.01"
							@input="changeTotalAmountOfProduct(scope.row)"
							:name="`${scope.$index}singleAmount`"
							:error="getError(`${scope.$index}singleAmount`)"
							placeholder="costo unitario"
							v-model="scope.row.singleAmount"/>
					</template>
				</el-table-column>
				<el-table-column
					width="150"
					label="Costo Totale (€)">
					<template slot-scope="scope">
						<base-input 
							v-validate="'required'"
							type="text"
							:name="`${scope.$index}totalAmount`"
							step="0.01"
							:error="getError(`${scope.$index}totalAmount`)"
							placeholder="totale"
							v-model="scope.row.totalAmount"/>
					</template>
				</el-table-column>
			</el-table>
		</card>

		<revision-technical-details
			:model="model"/>

		<div class="row justify-content-center">
			<div class="col-12 text-center">
				<h2><b>Totale : {{ total }}€</b></h2>
			</div>
			<div class="col-12 col-md-2">
				<base-checkbox
					v-model="model.sendTechnicalReport">
					Completa e invia report revisione
				</base-checkbox>
			</div>
			<div class="col-12 col-md-2 text-right" v-if="model.id">
				<base-button type="info" size="lg" @click="printPdf(`/#/print/engines/${$route.params.engineId}/final-revisions/${model.id}`)">
					Visualizza report
				</base-button>
			</div>
		</div>
		<iframe :src="printUrl" class="print-iframe" ref="printIframe" />
	</div>
</template>
<style lang="scss" scoped>
	textarea{
		min-height: 240px;
		&.text-area-notes{
			min-height: 0;
		}
	}
</style>
<script>
	import RevisionTechnicalDetails from './RevisionTechnichalDetails.vue'
	import { debounce } from "debounce"
	import { Table, TableColumn, Switch, Select, Option } from 'element-ui'
	import RevisionWorkedDetails from './RevisionWorkedDetails.vue'
	import RevisionWorkedAdditionalLines from './RevisionWorkedAdditionalLines.vue'

	export default {
		name: 'revision-final-form',
		components: {
			[TableColumn.name]: TableColumn,
			[Table.name]: Table,
			[Switch.name]: Switch,
			[Select.name]: Select,
			[Option.name]: Option,
			RevisionTechnicalDetails,
			RevisionWorkedAdditionalLines,
			RevisionWorkedDetails
		},
		props:{
			model: Object,
			site: Object,
			submit: Function,
		},
		watch: {
			printUrl(newValue){
				if (newValue){
					this.printLoading = true;
					setTimeout(()=>{
						const w = (this.$refs.printIframe.contentWindow || this.$refs.printIframe.contentDocument.defaultView);
						// w.print();
						this.printUrl = null;
						this.printLoading = false;
					},5000);
				}
			},
			site() {
				this.site.emails
					.some((email) => {
						if (email.primary){
							this.referent = email._id
							return email.primary
						}
					})
			},
			referent(newValue) {
				this.site.emails.some(email => {
					if (email._id === newValue){
						this.model.referent = email;
						return true;
					}
				})
			},
		},
		mounted() {
		},
		computed: {
			total() {
				//totale dato da 
				// calculateTotalOfWorkedDeatails per ogni key:
					// workedHours
					// holidayWorkedHours: Number,
					// tripHours: Number,
					// diem: Number,
					// overNight: Number,
					// totalKmTrip: Number,
				const workedDetailsKeys = ['workedHours', 'holidayWorkedHours', 'tripHours', 'diem', 'overNight', 'totalKmTrip'];
				let workedDetailsTotal = 0;
				workedDetailsKeys.forEach(key => {
					workedDetailsTotal += parseFloat(this.calculateTotalOfWorkedDeatails(key));
				})

				// Somma di tutte le model.workedDetails.additionalLines[i].amount
				let additionalLinesTotal = 0;
				this.model.workedDetails.additionalLines.forEach(line => {
					if (line.amount && ! isNaN(line.amount)){
						additionalLinesTotal += parseFloat(line.amount)
					}
				})

				// somma di tutti i prodotti
				// model.productsUsed[i].totalAmount
				let productsTotal = 0;
				this.model.productsUsed.forEach(product => {
					if ( product.totalAmount && ! isNaN(product.totalAmount)){
						productsTotal += parseFloat(product.totalAmount);
					}
				})

				// return workedDetailsTotal+productsTotal+additionalLinesTotal;
				return (workedDetailsTotal+productsTotal+additionalLinesTotal).toFixed(2);
			},
		},
		methods: {
			changePosition(i,howMuch){
				const destIndex = i + howMuch;
				this.model.productsUsed[i] = this.model.productsUsed.splice(destIndex, 1, this.model.productsUsed[i])[0];
				return this.model.productsUsed;
			},
			calculateTotalOfWorkedDeatails(key){
				let sum = 0;
				let total  = 0
				if ( this.model.workedDetails.days ){
					this.model.workedDetails.days.forEach(day => {
						sum = day[key] ? sum + parseFloat(day[key]) : sum;
					})
					total = parseFloat(this.model.workedDetails.detailsSingleAmount[key]) * sum;
				}else{
					return 0
				}
				return isNaN(total) ? 0 : total;
			},
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
			changeTotalAmountOfProduct(row){
				row.totalAmount = (parseFloat(row.quantity.replace(/,/, '.')) * parseFloat(row.singleAmount.replace(/,/, '.'))).toFixed(2)
			},
			printPdf(url) {
				this.printUrl = url;
			},
			calculateTotal(key){
				this.model.workedDetails[key].total = this.model.workedDetails[key].quantity*this.model.workedDetails[key].singleAmount
			},
			deleteProductRow(i) {
				this.model.productsUsed.splice(i,1)
			},
			addProduct(){
				this.model.productsUsed.push({})	
			},
			checkInput: debounce(function({target}){
				const lastDescription = this.model.productsUsed[this.model.productsUsed.length-1].description;
				const lastCode = this.model.productsUsed[this.model.productsUsed.length-1].description;
				if (lastDescription !== undefined
					&& lastDescription.length > 0
					&& lastCode !== undefined 
					&& lastCode.length > 0){
					this.model.productsUsed.push({})
				}
				const checkInputsLength = this.model.productsUsed.filter(product => {

					return (product.code === undefined || product.code.length === 0)
						&& (product.description === undefined || product.description.length === 0)
						&& (product.quantity === undefined || product.quantity.length === 0)
				}).length
				if (checkInputsLength > 1) {
					// rimuovi l'ultimo
					this.model.productsUsed.pop()
				}

			},500),
		},
		data(){
			return {
				printLoading: false,
				referent: null,
				printUrl: '',
			}
		}
	}
</script>
<style>
	.print-iframe{
		opacity: 0;
		height: 0;
	}
</style>